import React from 'react'
import { PrismicRichText } from '@prismicio/react'
import EmblaCarousel from '../embla/emblaCarousel'

const History = ({ autoplay, delayLength, loop, slice }) => {
  return (
    <section className='component-history mx-auto max-w-screen-xl p-4'>
      <div className='relative mt-8 overflow-hidden rounded bg-blue-100 py-10 px-8 text-primary'>
        <div className='prose mb-10 min-w-full text-center'>
          <PrismicRichText field={slice.primary.history_title.richText} />
        </div>
        <div className='my-4 lg:pb-16'>
          <EmblaCarousel arrows={true} autoplay={autoplay} loop={loop} delayLength={delayLength} slice={slice}>
            {slice.items.map((history, index) => {
              return (
                <div className='min-w-full' key={`history-${index}`}>
                  <div className='md:px-16 flex flex-col px-8 md:flex-row' key={`banner-${index}`}>
                    <div className='year'>{history.history_year}</div>
                    <div className='prose prose-lg mt-2 min-w-full text-primary md:ml-4 md:p-4'>
                      <PrismicRichText field={history.history_description.richText} />
                    </div>
                  </div>
                </div>
              )
            })}
          </EmblaCarousel>
        </div>
      </div>
    </section>
  )
}

export default History
